export default __webpack_public_path__ + "static/media/block-align-bottom.86780991.svg";